<template>
  <div v-bind:style='{left:obj.view.left + "px", top:obj.view.top + "px", width:obj.view.w + "px", height:obj.view.h + "px"}' class='flowchart-object jsplumb-draggable jsplumb-droppable' :id="obj.view.id">
    <div class="http_request_shell">
      <div class="title control">
        <div class="httpRequestTitle">{{$t('scenarios.konstruktor.canvas.add.sendHttpRequest')}}</div>
        <button class="delete" :aria-label="$t('common.actions.delete')" v-on:click="deleteNode()"></button>
      </div>

      <div style="margin-top: 6px">
        <div class="is-overlay overlay-for-not-admin"/>
        <div>
          <div class="field has-addons has-addons-centered">
            <p class="control">
              <span class="select">
                <select v-model="obj.data.method" class="method">
                  <option value="GET">GET</option>
                  <option value="POST">POST</option>
                </select>
              </span>
            </p>
            <p class = "control">
              <input class="input url" type="url" placeholder="url" v-model="obj.data.url">
            </p>
          </div>
        </div>
        <div class="paramsHeadersBody">
          <table>
            <thead>
              <th align="center">{{$t('scenarios.konstruktor.canvas.answer.httpRequest.params')}}</th>
              <th align="center">{{$t('scenarios.konstruktor.canvas.answer.httpRequest.headers')}}</th>
              <th align="center">{{$t('scenarios.konstruktor.canvas.answer.httpRequest.body')}}</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="paramsList">
                    <table>
<!--                      <thead>-->
<!--                      <th>ключ</th>-->
<!--                      <th>значени</th>-->
<!--                      </thead>-->
                      <tbody>
                      <tr v-for="(param, index) in paramsAsList" class="param">
                        <td class="control"><input v-model="param.key" class="input key" type="text" :placeholder="$t('common.key')"></td>
                        <td class="control"><input v-model="param.value" class="input value" type="text" :placeholder="$t('common.value')"></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
                <td>
                  <div class="headersList">
                    <table>
<!--                      <thead>-->
<!--                      <th>ключ</th>-->
<!--                      <th>значени</th>-->
<!--                      </thead>-->
                      <tbody>
                      <tr v-for="(header, index) in headersAsList" class="header">
                        <td class="control"><input v-model="header.key" class="input key" type="text" :placeholder="$t('common.key')"></td>
                        <td class="control"><input v-model="header.value" class="input value" type="text" :placeholder="$t('common.value')"></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </td>
                <td>
                  <div class="bodyTd">
                    <textarea v-model="obj.data.body" placeholder="json" title="json" class="textarea body"/>
                  </div>

                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
    import {BaseNodeComponent} from './jsplumb-extends/jsplumb-vue'

    export default {
        name: 'HttpRequest',
        mixins:[ BaseNodeComponent ],
        data() {
          return {
            headersAsList: [],
            paramsAsList: []
          }
        },
        created() {
          for (let key in this.obj.data.headers) {
            this.headersAsList.push({
              key: key,
              value: this.obj.data.headers[key]
            })
          }
          for (let i = this.headersAsList.length; i < 4; i++) {
            this.headersAsList.push({
              key: '',
              value: ''
            })
          }

          for (let key in this.obj.data.params) {
            this.paramsAsList.push({
              key: key,
              value: this.obj.data.params[key]
            })
          }
          for (let i = this.paramsAsList.length; i < 4; i++) {
            this.paramsAsList.push({
              key: '',
              value: ''
            })
          }
        }
    }
</script>

<style scoped>
  .http_request_shell {
    border-radius: 10px;
    vertical-align: top;
    background-color: ghostwhite;
    padding: 10px;
    /*height: 100%;*/
    /*width: 512px;*/
  }
  .title .delete {
    float: right;
    background-color: indianred;
    cursor: pointer;
  }
  .title {
    font-size: 16px;
    white-space: nowrap;
    text-align: left;
    height: 32px;
    margin-bottom: 0;
    display: inline;
  }

  .http_request_shell .title .httpRequestTitle {
    padding-right: 16px;
    font-size: 16px;
  }

  .http_request_shell .title div {
    display: inline;
  }

  .body {
    height: 128px;
    /*min-height: 80px;*/
    /*min-max: 80px;*/
    resize: none;
  }

  .field {
    /*float:left;*/
    vertical-align: middle;
    /*margin-bottom: -10px;*/
  }
  .field-label {
    height: 40px;
  }

  .field.has-addons .control:not(:last-child) {
    margin-right: -1px;
  }
  .field.has-addons.has-addons-centered {
    justify-content: center;
  }

  .field.has-addons {
    display: flex;
    justify-content: flex-start;
  }
  select, input {
    height: 32px;
  }
  .select {
    display: inline-block;
    max-width: 100%;
    position: relative;
    vertical-align: top;
  }

  span {
    font-style: inherit;
    font-weight: inherit;
  }
  /*.field.has-addons .control:first-child:not(:only-child) .button, .field.has-addons .control:first-child:not(:only-child) .input, .field.has-addons .control:first-child:not(:only-child) .select select {*/
  /*  border-bottom-right-radius: 0;*/
  /*  border-top-right-radius: 0;*/
  /*}*/
  .select select:not([multiple]) {
    padding-right: 2.5em;
  }
  .select select {
    cursor: pointer;
    display: block;
    max-width: 100%;
    outline: 0;
    font-size: initial;
  }
  /*body, button, input, select, textarea {*/
  /*  font-family: BlinkMacSystemFont,-apple-system,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",Helvetica,Arial,sans-serif;*/
  /*}*/

  button, input, select, textarea {
    margin: 0;
  }
  .select:not(.is-multiple):not(.is-loading)::after {
    border-color: #3273dc;
    right: 1.125em;
    z-index: 4;
  }


  .is-overlay {
    /*height: 155px;*/
    z-index: 100;
  }

  input.url {
    width: 804px;
  }

  /*table {*/
  /*  margin:8px*/
  /*}*/

  .paramsList, .headersList, .bodyTd {
    min-width: 270px;
    max-width: 330px;
  }

  .paramsList {
    margin-right: 4px;
  }

  .headersList {
    margin-left: 4px;
    margin-right: 4px;
  }

  .bodyTd {
    margin-left: 4px;
    max-width: 360px;
    min-width: 343px;
  }

  .paramsHeadersBody {
    /*position: absolute;*/
    margin-top: 8px;
  }

  th {
    font-size: large;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// HttpRequest.vue?49acf3a2